import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import Range from "react-rangeslider";
import PainImage from "../../assets/pain-faces@2x.jpg";
import { getLocaleSpecificProp } from "modules/i18n/locale-utils";

import BrandHelper from "../../brand/brand-helper";

class PainVASCmp extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
    value: PropTypes.number,
    initialValue: PropTypes.number,
    step: PropTypes.number,
    question: PropTypes.object,
    translatedLabel: PropTypes.string,
    intl: intlShape.isRequired,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
      warning: PropTypes.string
    }),
    painScale: PropTypes.array
  };

  static defaultProps = {
    min: 0,
    max: 100,
    painScale: [
      {
        caption: "PAIN FREE",
        min: 0,
        max: 0,
        label: "vas-slider.lvl_1",
        desc: "vas-slider.lvl_1_desc"
      },
      {
        caption: "MILD PAIN",
        min: 1,
        max: 9,
        label: "vas-slider.lvl_2",
        desc: "vas-slider.lvl_2_desc"
      },
      {
        caption: "MILD PAIN",
        min: 10,
        max: 19,
        label: "vas-slider.lvl_3",
        desc: "vas-slider.lvl_3_desc"
      },
      {
        caption: "MILD PAIN",
        min: 20,
        max: 29,
        label: "vas-slider.lvl_4",
        desc: "vas-slider.lvl_4_desc"
      },
      {
        caption: "MODERATE PAIN",
        min: 30,
        max: 39,
        label: "vas-slider.lvl_5",
        desc: "vas-slider.lvl_5_desc"
      },
      {
        caption: "MODERATE PAIN",
        min: 40,
        max: 49,
        label: "vas-slider.lvl_6",
        desc: "vas-slider.lvl_6_desc"
      },
      {
        caption: "MODERATE PAIN",
        min: 50,
        max: 59,
        label: "vas-slider.lvl_7",
        desc: "vas-slider.lvl_7_desc"
      },
      {
        caption: "SEVERE PAIN",
        min: 60,
        max: 69,
        label: "vas-slider.lvl_8",
        desc: "vas-slider.lvl_8_desc"
      },
      {
        caption: "SEVERE PAIN",
        min: 70,
        max: 79,
        label: "vas-slider.lvl_9",
        desc: "vas-slider.lvl_9_desc"
      },
      {
        caption: "SEVERE PAIN",
        min: 80,
        max: 89,
        label: "vas-slider.lvl_10",
        desc: "vas-slider.lvl_10_desc"
      },
      {
        caption: "SEVERE PAIN",
        min: 90,
        max: 100,
        label: "vas-slider.lvl_11",
        desc: "vas-slider.lvl_11_desc"
      }
    ]
  };

  constructor(props) {
    super(props);
    const { input, min, initialValue = min } = props;
    if (
      input.value === undefined ||
      input.value === null ||
      input.value === ""
    ) {
      input.value = initialValue;
    }
  }

  countImageOffset = () => {
    const {
      input: { value }
    } = this.props;
    return (
      this.props.painScale.findIndex(
        item => item.min <= value && item.max >= value
      ) * -100
    );
  };

  renderText = key => {
    const {
      input: { value }
    } = this.props;
    return this.props.painScale.find(
      item => item.min <= value && item.max >= value
    )[key];
  };

  render() {
    const {
      input,
      min,
      max,
      step = 1,
      meta: { touched, error, warning },
      question,
      intl: { locale }
    } = this.props;

    const brand = BrandHelper.getMyDomainObject();
    const style = { backgroundColor: brand.backgroundColor };

    return (
      <div className="QuestionForm-answer-painVAS" style={style}>
        <h2>{getLocaleSpecificProp(question, locale)}</h2>
        <output>{input.value}</output>
        <Range
          min={min}
          max={max}
          step={step}
          value={input.value}
          labels={{ [min]: min, [max]: max }}
          onChange={input.onChange}
          tooltip={false}
        />
        <div className="PainScale">
          <span className="PainLabel">
            <FormattedMessage
              id={this.renderText("label")}
              values={{
                break: <br />
              }}
            />
          </span>
          <span className="PainImage">
            <img
              src={PainImage}
              alt="Pain"
              style={{ top: this.countImageOffset() + "%" }}
            />
          </span>
          <span className="PainDesc">
            <FormattedMessage id={this.renderText("desc")} />
          </span>
        </div>

        {touched &&
          ((error && (
            <span>
              <FormattedMessage id={error} />
            </span>
          )) ||
            (warning && (
              <span>
                <FormattedMessage id={warning} />
              </span>
            )))}
      </div>
    );
  }
}

const PainVAS = props => <Field component={PainVASCmp} {...props} />;

export default injectIntl(PainVAS);



// WEBPACK FOOTER //
// ./src/modules/forms/fields/pain-vas.js